import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Rating,
  Box
} from '@mui/material';

const sources = [
  'TripAdvisor',
  'Booking.com',
  'Agoda',
  'Expedia',
  'Verbal/Offline',
  'Email',
];

export default function ReviewForm({ open, onClose, onSave, initialData }) {
  initialData = initialData || {};
  const [guestName, setGuestName] = useState(initialData.guestName || '');
  const [rating, setRating] = useState(initialData.rating || 0);
  const [date, setDate] = useState(initialData.date || new Date().toISOString().split('T')[0]);
  const [title, setTitle] = useState(initialData.title || '');
  const [content, setContent] = useState(initialData.content || '');
  const [source, setSource] = useState(initialData.source || 'TripAdvisor');
  const [submittedBy, setSubmittedBy] = useState(initialData.submittedBy || '');

  const handleSubmit = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const propertyId = user?.property?._id;
    onSave({
      _id: initialData._id,
      guestName,
      rating,
      date,
      title,
      content,
      source,
      submittedBy,
      propertyId
    });
  };

  useEffect(() => {
    console.log('Initial data:', initialData);
    if (initialData && Object.keys(initialData).length > 0) {
      setGuestName(initialData.guestName || '');
      setRating(initialData.rating || 0);
      setDate(initialData.date ? new Date(initialData.date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]);
      setTitle(initialData.title || '');
      setContent(initialData.content || '');
      setSource(initialData.source || 'TripAdvisor');
      setSubmittedBy(initialData.submittedBy || '');
    }
  }, [initialData]);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData._id ? 'Edit Review' : 'Add New Review'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Guest Name"
          value={guestName}
          onChange={(e) => setGuestName(e.target.value)}
          fullWidth
          margin="normal"
        />

        <Box display="flex" alignItems="center" mt={2}>
          <span style={{ marginRight: 8 }}>Rating:</span>
          <Rating
            name="rating"
            value={rating}
            onChange={(_, newValue) => setRating(newValue)}
          />
        </Box>

        <TextField
          label="Date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Review Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Review Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          minRows={3}
        />

        <TextField
          select
          label="Review Source"
          value={source}
          onChange={(e) => setSource(e.target.value)}
          fullWidth
          margin="normal"
        >
          {sources.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>

        <TextField
          label="Submitted By (staff)"
          value={submittedBy}
          onChange={(e) => setSubmittedBy(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
